import script from "./DepositPaymentMethods.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositPaymentMethods.vue?vue&type=script&setup=true&lang=js"

import "./DepositPaymentMethods.vue?vue&type=style&index=0&id=7b7d99fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b7d99fd"]])

export default __exports__